<template lang="pug">
v-skeleton-loader(type="list-item-avatar, list-item-three-line", loading)
</template>

<script lang="ts">
import Vue from "vue"

export default Vue.extend({
  name: "CommentLoading",
})
</script>
